export default defineAppConfig({
  ui: {
    // primary: 'blue',
    // primary: 'azure-radiance',
    // primary: 'sky',
    // primary: 'blue-ribbon',
    primary: 'stark-gold',
    gray: 'neutral',
  }
})
